import { FC } from "preact/compat";
import EmblemIcon from "~/assets/engage-logo.svg";
import Loader from "~/assets/loader.svg";
import BottomIcon from "~/assets/marathon-by-kase.svg";

const LoadingScreen: FC = () => (
    <div
        style={{
            backgroundImage: "url('/_assets/login-bg.jpeg')",
            backgroundSize: "cover",
            backgroundPosition: "center",
        }}
        className="max-w-screen relative -top-safe-top flex h-screen max-h-screen w-screen flex-col items-center justify-center overflow-hidden text-white bg-sky-950"
    >
        <div>
            <EmblemIcon className="max-w-full px-4 md:px-0" />
        </div>
        <div className="mt-12">
            <div className="flex min-h-[56px] items-center gap-x-2">
                <Loader width="32" height="32" />
                <span>Authorizing</span>
            </div>
        </div>
        <div className="absolute bottom-2 left-1/2 -translate-x-1/2 md:bottom-6 md:left-auto md:right-6 md:translate-x-0">
            <BottomIcon className="max-w-[60vw]" />
        </div>
    </div>
);

export default LoadingScreen;
